import createWorkerFunction_ from "./createWorkerFunction_.js";
export default function createStreamingWorkerFunction(createWorkerInEnvironment, fnOrAlias) {
    // When the worker function streams output data, this listener Listens to the output in the main thread.
    let streamingOutputListener = undefined;
    // When the worker function streams output data, this listener Listens to any errors that happen in the worker thread.
    let streamingErrorListener = undefined;
    // Declare a worker function. It will be returned from this function.
    const createMethods = (start, stop, started, stopped, sendToWorker, mustHaveStarted, mustNotHaveStarted, mustNotHaveStopped) => ({
        // Defines the listener of the responses from the worker.
        onOutput(listener) {
            mustNotHaveStopped();
            mustNotHaveStarted();
            // When called multiple times, it'll just overwrite the listener.
            // This behavior is convenient when a worker function gets reused.
            // if (streamingOutputListener) {
            // 	throw new Error('Already listening')
            // }
            streamingOutputListener = listener;
            // isStreamingFn = true
        },
        // Defines the listener of the responses from the worker.
        onError(listener) {
            mustNotHaveStopped();
            mustNotHaveStarted();
            // When called multiple times, it'll just overwrite the listener.
            // This behavior is convenient when a worker function gets reused.
            // if (streamingErrorListener) {
            // 	throw new Error('Already set up')
            // }
            streamingErrorListener = listener;
            // isStreamingFn = true
        },
        // Pushes input data to a listenable function.
        send(input) {
            mustNotHaveStopped();
            mustHaveStarted();
            sendToWorker([input]);
        }
    });
    // This function will be executed in the worker thread.
    // It will be stringified and injected in the worker source code.
    // Therefore, it should be a "self-contained" function,
    // i.e. it shouldn't reference anything outside of its body.
    const createInputHandler = (fn, send) => {
        const inputHandler = fn(send);
        return ([input]) => {
            inputHandler(input);
        };
    };
    // This function will be executed in the main thread.
    // Currently, we are in the main thread.
    const handleError = (error) => {
        if (streamingErrorListener) {
            streamingErrorListener(error);
        }
        else {
            throw error;
        }
    };
    // This function will be executed in the main thread.
    // Currently, we are in the main thread.
    const handleOutput = (output) => {
        if (streamingOutputListener) {
            streamingOutputListener(output);
        }
        else {
            console.warn('[worker-f] Response missed', output);
        }
    };
    return createWorkerFunction_(createWorkerInEnvironment, fnOrAlias, createMethods, createInputHandler, handleError, handleOutput);
}
